<template>
  <div>
    <div class="heard">
      <div class="main">
        <div class="logo"><img src="@/assets/images/logo.png"/>
          姐弟俩
          <br>
          智能订货平台
        </div>
        <div class="heard_main">
          <div class="sousuo"><input v-model="keywords" @keyup.enter="searchKeyWords" class="sousuo_text" type="text"/>
            <button @click="searchKeyWords()" style="cursor: pointer">搜索</button>
          </div>
        </div>
        <a class="shopping_cart" @click="$router.push('/shopRestock')" href="javascript:void(0)"><img
            src="@/assets/images/cart.png"/><span>智能订货</span></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'searchBar',
  data () {
    return {
      keywords: '',
    }
  },
  methods: {
    searchKeyWords () {
      this.$router.push(
          {
            name: 'goodsList',
            params: {keywords: this.keywords},
            query: {
              t: Date.now(),
            }
          })
    }
  },
}
</script>

<style scoped>
@import "../../assets/style/index.css";
</style>



// WEBPACK FOOTER //
// src/components/search/searchBar.vue